export * from '../../app/services/api/attributesAllergens/attributesAllergensTypes';

export enum AttributeDetailTab {
  Overview = 'overview',
  Usage = 'usage',
  Conflicts = 'conflicts',
}
